import {getUserInitials} from "../../utils/utils";
import React from "react";
import {useData} from "./Calendar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faNoteSticky, faUmbrellaBeach} from "@fortawesome/free-solid-svg-icons";
import CUSTOM_EVENT_TYPE from "./CustomEventType";


export default function CustomEvent({event, onClick,day, currentdate}) {

    const maxSpan = 7-day+1
    const daysTilEnd = calculateDaysTillEventEnd(event.date_to, currentdate);
    const { workers} = useData();
    const dateFrom = new Date(event.date_from).toLocaleDateString()
    const dateTo = new Date(event.date_to).toLocaleDateString()

    const span = Math.min(maxSpan, daysTilEnd+1)

    let users = [];


    if(event.users)
        users = workers.filter(w=>event.users.findIndex(u=>u.id === w.id) > -1);

    let primeBgColor = 'rgba(200,200,200,.1)';

    if((users[0])?.color !== undefined) {
        primeBgColor = users[0].color.replace(")", ",25%)")
    }


    return (
        <div className={`day_${day} customEvent span_${span}`} style={{backgroundColor:primeBgColor}} title={`od ${dateFrom} do ${dateTo}`} onClick={()=>{onClick(event)}}>
            <div className={"eventBody"}>
                <FontAwesomeIcon className={"me-1"} icon={getCustomEventIcon(event.type)} />
                {event.value}
                {
                    users?.map(user=>
                        <span key={user.id} className={"userBadge float-end"} style={{backgroundColor:user.color}} title={user.name}>{getUserInitials(user)}</span>
                    )
                }
            </div>
        </div>
    )
}

function getCustomEventIcon(type){
    if(type === CUSTOM_EVENT_TYPE.VACATION)
        return faUmbrellaBeach;

    return faNoteSticky;
}

function calculateDaysTillEventEnd(dateTo, currentDate){

    const timeSpanTo = Date.parse(dateTo.split('T')[0])
    const timeSPanCurrent = Date.parse(currentDate.toJSON().split('T')[0])


    const diffDays = ((timeSpanTo - timeSPanCurrent)/1000)/(24*3600)

    return diffDays

}
